import { render } from "./SliderBar.vue?vue&type=template&id=33cb43d4"
import script from "./SliderBar.vue?vue&type=script&lang=js"
export * from "./SliderBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__